import classNames from 'classnames';
import { useMemo } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { Heading, List } from 'yoso';
import { BaseCard } from '~/components/Card';
import { Translation } from '~/components/I18n';
import { useLand } from '~/components/Land';
import { useLandEvent } from '~/components/Land/Event';
import { landMeta } from '~/components/Land/Land.meta';
import landStyles from '~/components/Style/Land.module.scss';
import styles from './OtherLandList.module.scss';

export type OtherLandListProps = {
  className?: string;
  landId: number;
};

export const OtherLandList = ({ className, landId }: OtherLandListProps) => {
  const {
    data: { week },
  } = useLand(landId);

  const {
    data: { landList },
  } = useLandEvent(week, { enabled: !!week });

  const otherLands = useMemo(
    () =>
      landList
        .filter((each) => each.landId !== landId)
        .sort((landA, landB) => landB.citizenNftLevel - landA.citizenNftLevel),
    [landId, landList]
  );

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>
        <Heading level={5} className={styles.title}>
          <Translation name="citizen_land_join_complete_popup_other_desc1" />
        </Heading>
      </div>
      <div className={styles.body}>
        <List className={styles.list}>
          {otherLands.map((each) => (
            <li key={each.landId}>
              <BaseCard<LinkProps>
                as={Link}
                className={classNames(styles.card, landStyles[each.landType])}
                to={`/land/event/${week}/land/${each.landId}`}>
                <p className={styles.cardTitle}>
                  <Translation
                    name="citizen_land_join_complete_popup_other_desc2"
                    options={[landMeta[each.landType].title]}
                  />
                </p>
              </BaseCard>
            </li>
          ))}
        </List>
      </div>
    </div>
  );
};
